import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'urgent';
  size?: 'md' | 'lg' | 'xl';
  children: React.ReactNode;
  fullWidth?: boolean;
}
export function Button({
  variant = 'primary',
  size = 'lg',
  children,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-cream';
  const variants = {
    primary: 'bg-sage-400 text-white hover:bg-sage-500 focus:ring-sage-400 shadow-lg shadow-sage-400/20',
    secondary: 'bg-cream-dark text-charcoal-800 hover:bg-[#EBE0D5] focus:ring-charcoal-700',
    urgent: 'bg-coral-500 text-white hover:bg-coral-600 focus:ring-coral-500 shadow-lg shadow-coral-500/20'
  };
  const sizes = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-109">
      {children}
    </motion.button>;
}